"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return [["لا", "ولا"], ["إما", "أو"], ["ربما", "ربما"], ["حينئذ", "عندئذ"], ["إما", "وإما"], ["كل من", "و"]];
};